<template>
  <div class="detail__">
    <div class="detail_box">
      <div class="floatHeader" v-if="pageheight > 180">
        <span>{{ casenew.Casename }}</span>
      </div>
      <div class="box" ref="backTop" id="top">
        <div
          class="detail"
          :style="
            !lawtkxs_show && !relations_show && !relations_show
              ? 'width: calc(100% - 150px);'
              : 'width: calc(100% - 420px);'
          "
        >
          <div class="breadcrumb">
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              style="display: flex; font-size: 16px"
            >
              <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
              <el-breadcrumb-item :to="{ path: '/case' }" style="width: 80px"
                >搜案例</el-breadcrumb-item
              >
              <el-breadcrumb-item>{{ casenew.Casename }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <div class="box_main">
            <div class="title" id="item000">
              <div style="display: flex; align-items: center; width: 100%">
                <h1 style="font-family: '思源黑体CN'">
                  {{ casenew.Casename }}
                </h1>
                <!-- <p><span>推荐时间：2018-05-29</span><span>推荐人：罗奎</span></p> -->
              </div>
              <div
                class="sicoriginal"
                style="display: flex; justify-content: flex-end"
              >
                <!-- <router-link
              :to="{ path: `/original/${caseId}` }"
              target="_blank"
              style="line-height: 36px"
              ><el-button type="warning" style="padding: 10px 10px"
                >查看原文</el-button
              ></router-link
            > -->
                <div
                  class="collection"
                  v-if="!casenew.coll"
                  style="line-height: 36px; margin-left: 20px"
                >
                  <el-tooltip content="收藏" placement="left" effect="light">
                    <img
                      @click="collectible(casenew)"
                      src="../../../../assets/imgs/2.0/_收藏.png"
                      alt=""
                    />
                  </el-tooltip>
                </div>
                <div
                  class="collection"
                  v-if="casenew.coll"
                  style="line-height: 36px; margin-left: 20px"
                >
                  <el-tooltip content="收藏" placement="left" effect="light">
                    <img
                      v-if="casenew.coll == 0"
                      @click="collectible(casenew)"
                      src="../../../../assets/imgs/2.0/_收藏.png"
                      alt=""
                    />
                  </el-tooltip>
                  <el-popconfirm
                    title="确认取消收藏吗？"
                    @confirm="cancel(casenew)"
                  >
                    <img
                      slot="reference"
                      v-if="casenew.coll == 1"
                      src="../../../../assets/imgs/2.0/收藏3.png"
                      alt=""
                    />
                  </el-popconfirm>
                </div>
                <el-dropdown style="line-height: 36px; margin-left: 20px">
                  <!-- <el-button
                type="warning"
                style="padding: 10px 10px; width: 78px; margin-right: 10px"
                >下载<i class="el-icon-download"></i
              ></el-button> -->
                  <el-button
                    type="warning"
                    icon="el-icon-download"
                    style="padding: 10px 10px; margin-right: 10px"
                    circle
                    size="mini"
                  ></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      ><img
                        class="down_icon"
                        src="../../../../assets/imgs/图标/pdf (1).png"
                        alt=""
                      />
                      <span @click="pdfDown(caseId)"
                        >PDF文件</span
                      ></el-dropdown-item
                    >
                    <el-dropdown-item
                      ><span @click="wordDown(caseId)"
                        ><img
                          class="down_icon"
                          src="../../../../assets/imgs/图标/word.png"
                          alt=""
                        />
                        WORD文件</span
                      ></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="box_botton">
              <div class="box_nav">
                <div class="post">
                  <div
                    v-for="(item, index) in boxNav"
                    :key="index"
                    class="active__"
                    :class="[item == naveffect ? 'active' : '']"
                  >
                    <span @click="boxnav(item, index)">{{ item }}</span>
                  </div>
                </div>
                <!-- <span>基本信息</span>
        <span>首部</span>
        <span>详情</span>
        <span>判决结果</span>
        <span>法律适用</span>
        <span>审计日期</span> -->
              </div>
              <div
                class="box_body"
                ref="backTop"
                id="top"
                v-if="content !== ''"
              >
                <div class="txt" id="item00">
                  <h2>基本信息</h2>
                  <div class="content font_size">
                    <span v-if="casenew.CaseId" class="span_css"
                      >案&emsp;&emsp;号：{{ casenew.CaseId }}</span
                    >
                    <span v-if="casenew.CaseType" class="span_css"
                      >案件类型：{{ casenew.CaseType }}</span
                    >

                    <span v-if="casenew.Court" class="span_css"
                      >审理法院：
                      <!-- {{ casenew.Court.names[casenew.Court.names.length - 1] }} -->
                      {{ cours_name }}
                    </span>
                    <span v-if="casenew.TrialPro" class="span_css"
                      >审理程序：{{ casenew.TrialPro }}</span
                    >
                    <span v-if="casenew.RefereeDate" class="span_css"
                      >裁判日期：{{ casenew.RefereeDate }}</span
                    >
                    <span v-if="casenew.Cause_Reason" class="span_brief"
                      ><span class="span_tit"> 案&emsp;&emsp;由：</span>
                      <span class="span_txt">
                        <span
                          v-for="(item, index) in briefs"
                          :key="index"
                          @click="search_brief(item)"
                        >
                          <span class="hover_brief">{{ item.name }} </span>
                          <span v-if="index < briefs.length - 1">>> </span>
                        </span>
                      </span>
                    </span>
                    <span
                      v-if="casenew.Keyword && casenew.Keyword.length > 0"
                      class="span_brief"
                      ><span class="span_tit">关&ensp;键&ensp;词：</span>
                      <span class="span_txt">
                        <span
                          v-for="(item, index) in casenew.Keyword"
                          :key="index"
                        >
                          <!-- @click="search_brief(item)" -->
                          <span class="hover_brief_word">{{ item }} </span>
                          <span v-if="index < casenew.Keyword.length - 1"
                            >；
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  class="txt"
                  v-if="
                    casenew.Party &&
                    casenew.Party.length > 1 &&
                    parties[0].type &&
                    parties[1].type &&
                    parties[0].type !== '' &&
                    parties[1].type !== ''
                  "
                >
                  <!-- && parties[0].type !=='' && parties[1].type !=='' -->
                  <h2>当事人</h2>
                  <div class="content0">
                    <div class="party">
                      <p>
                        <!-- <span
                        style="width: 80px"
                        class="figure.tit"
                        v-if="parties[1].type !== ''"
                        >{{ parties[0].type }}: </span
                      ><span style="width: 80px" class="figure.tit" v-else
                        >原告:
                      </span> -->
                        <span class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            v-if="parties[0].type !== ','"
                            >{{
                              parties[0].type.substring(
                                0,
                                parties[0].type.length - 1
                              )
                            }}:
                          </span>
                          <el-popover placement="top-start" trigger="hover">
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                                v-if="parties[0].type !== ','"
                              >
                                {{
                                  parties[0].type.substring(
                                    0,
                                    parties[0].type.length - 1
                                  )
                                }}
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[0].name.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference" class="figure_txt">{{
                              parties[0].name.substring(
                                0,
                                parties[0].name.length - 1
                              )
                            }}</span>
                          </el-popover>
                        </span>
                      </p>
                      <p>
                        <!-- <span class="figure.tit">律师：</span> -->
                        <!-- <span class="figure">{{ parties[0].law_name }}</span> -->
                        <span class="figure" v-if="parties[0].lawer !== ''"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          <el-popover
                            placement="top-start"
                            trigger="hover"
                            v-if="parties[0].lawer !== ''"
                          >
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                              >
                                律师
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[0].lawer.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference">{{
                              parties[0].lawer.substring(
                                0,
                                parties[0].lawer.length - 1
                              )
                            }}</span>
                          </el-popover>
                        </span>
                        <!-- <el-popover
                        placement="right"
                        trigger="hover"
                        v-if="parties[0].lawer !== ''"
                      >
                        <div class="pop_txt">
                          <p
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                          >
                            律师
                          </p>
                          <p
                            v-for="(item_name, index) in parties[0].lawer.split(
                              ','
                            )"
                            :key="index"
                          >
                            {{ item_name }}
                          </p>
                        </div>
                        <span slot="reference" class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          {{
                            parties[0].lawer.substring(
                              0,
                              parties[0].lawer.length - 1
                            )
                          }}</span
                        >
                      </el-popover> -->
                        <span class="figure" v-else
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          --</span
                        >
                      </p>
                      <p>
                        <!-- <span class="figure.tit"> 律所：</span> -->
                        <span class="figure" v-if="parties[0].lawfirm !== ''"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >
                          <el-popover placement="top-start" trigger="hover">
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                              >
                                律所
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[0].lawfirm.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference">{{
                              parties[0].lawfirm.substring(
                                0,
                                parties[0].lawfirm.length - 1
                              )
                            }}</span>
                          </el-popover>
                        </span>
                        <!-- <el-popover
                        placement="right"
                        trigger="hover"
                        v-if="parties[0].lawfirm !== ''"
                      >
                        <div class="pop_txt">
                          <p
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                          >
                            律所
                          </p>
                          <p
                            v-for="(
                              item_name, index
                            ) in parties[0].lawfirm.split(',')"
                            :key="index"
                          >
                            {{ item_name }}
                          </p>
                        </div>
                        <span slot="reference" class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >{{
                            parties[0].lawfirm.substring(
                              0,
                              parties[0].lawfirm.length - 1
                            )
                          }}</span
                        ></el-popover
                      > -->
                        <span class="figure" v-else
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >
                          --
                        </span>
                      </p>
                    </div>
                    <img
                      src="../../../../assets/imgs/文书详情二期/u51.png"
                      alt=""
                    />
                    <div class="party">
                      <p>
                        <span class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            v-if="parties[1].type !== ','"
                            >{{
                              parties[1].type.substring(
                                0,
                                parties[1].type.length - 1
                              )
                            }}:
                          </span>
                          <el-popover placement="top-start" trigger="hover">
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                                v-if="parties[1].type !== ''"
                              >
                                {{
                                  parties[1].type.substring(
                                    0,
                                    parties[1].type.length - 1
                                  )
                                }}
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[1].name.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference">{{
                              parties[1].name.substring(
                                0,
                                parties[1].name.length - 1
                              )
                            }}</span>
                          </el-popover>
                        </span>
                        <!-- <el-popover placement="right" trigger="hover">
                        <div class="pop_txt">
                          <p
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            v-if="parties[1].type !== ''"
                          >
                            {{
                              parties[1].type.substring(
                                0,
                                parties[1].type.length - 1
                              )
                            }}
                          </p>
                          <p
                            v-for="(item_name, index) in parties[1].name.split(
                              ','
                            )"
                            :key="index"
                          >
                            {{ item_name }}
                          </p>
                        </div>
                        <span slot="reference" class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            v-if="parties[1].type !== ''"
                            >{{
                              parties[1].type.substring(
                                0,
                                parties[1].type.length - 1
                              )
                            }}: </span
                          >{{
                            parties[1].name.substring(
                              0,
                              parties[1].name.length - 1
                            )
                          }}</span
                        >
                      </el-popover> -->
                      </p>
                      <p>
                        <!-- <el-popover
                        placement="right"
                        trigger="hover"
                        v-if="parties[1].lawer !== ''"
                      >
                        <div class="pop_txt">
                          <p
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                          >
                            律师
                          </p>
                          <p
                            v-for="(item_name, index) in parties[1].lawer.split(
                              ','
                            )"
                            :key="index"
                          >
                            {{ item_name }}
                          </p>
                        </div>
                        <span slot="reference" class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          {{
                            parties[1].lawer.substring(
                              0,
                              parties[1].lawer.length - 1
                            )
                          }}</span
                        >
                      </el-popover> -->

                        <span class="figure" v-if="parties[1].lawer !== ''"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          <el-popover
                            placement="top-start"
                            trigger="hover"
                            v-if="parties[1].lawer !== ''"
                          >
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                              >
                                律师
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[1].lawer.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference">{{
                              parties[1].lawer.substring(
                                0,
                                parties[1].lawer.length - 1
                              )
                            }}</span>
                          </el-popover> </span
                        ><span class="figure" v-else
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律师:</span
                          >
                          --</span
                        >
                      </p>
                      <p>
                        <!-- <el-popover
                        placement="right"
                        trigger="hover"
                        v-if="parties[1].lawfirm !== ''"
                      >
                        <div class="pop_txt">
                          <p
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                          >
                            律所
                          </p>
                          <p
                            v-for="(
                              item_name, index
                            ) in parties[1].lawfirm.split(',')"
                            :key="index"
                          >
                            {{ item_name }}
                          </p>
                        </div>
                        <span slot="reference" class="figure"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >
                          {{
                            parties[1].lawfirm.substring(
                              0,
                              parties[1].lawfirm.length - 1
                            )
                          }}</span
                        ></el-popover
                      > -->
                        <span class="figure" v-if="parties[1].lawfirm !== ''"
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >
                          <el-popover placement="top-start" trigger="hover">
                            <div class="pop_txt">
                              <p
                                style="
                                  color: #e6a23c;
                                  font-weight: 600;
                                  letter-spacing: 1px;
                                "
                              >
                                律所
                              </p>
                              <p
                                v-for="(
                                  item_name, index
                                ) in parties[1].lawfirm.split(',')"
                                :key="index"
                              >
                                {{ item_name }}
                              </p>
                            </div>
                            <span slot="reference">{{
                              parties[1].lawfirm.substring(
                                0,
                                parties[1].lawfirm.length - 1
                              )
                            }}</span>
                          </el-popover>
                        </span>
                        <span class="figure" v-else
                          ><span
                            style="
                              color: #e6a23c;
                              font-weight: 600;
                              letter-spacing: 1px;
                            "
                            >律所:</span
                          >
                          --</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <div class="txt" id="item00" v-if="casenew.Trial">
                  <h2>庭审视频链接</h2>
                  <div
                    class="content"
                    style="
                      padding: 20px 30px;
                      display: flex;
                      justify-content: space-around;
                      align-items: center;
                    "
                  >
                    <div
                      style="
                        display: inline-block;
                        width: 35%;
                        height: 143px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <img
                        v-if="casenew.Trial.img_link.includes('showPlay')"
                        style="
                          max-width: 100%;
                          max-height: 160px;
                          border-radius: 5px;
                        "
                        src="../../../../assets/imgs/picwish(1).png"
                        alt=""
                      />
                      <img
                        v-else
                        style="
                          max-width: 100%;
                          max-height: 143px;
                          border-radius: 5px;
                        "
                        :src="casenew.Trial.img_link"
                        alt=""
                      />
                    </div>

                    <div style="margin: 0 20px; width: 30%">
                      <span
                        v-if="casenew.Trial.Locate"
                        style="height: 30px; line-height: 30px"
                        class="span_css"
                        >庭审地点：{{ casenew.Trial.Locate }}</span
                      >
                      <span
                        v-if="casenew.Trial.BeginTime"
                        style="height: 30px; line-height: 30px"
                        class="span_css"
                        >开庭时间：{{ casenew.Trial.BeginTime }}</span
                      >

                      <div>
                        <el-button
                          type="warning"
                          round
                          @click="video_link(casenew.Trial.video_link)"
                          class="btn"
                          size="mini"
                          style="margin: 10px 0px 0 0"
                          >庭审视频链接</el-button
                        >
                      </div>

                      <p
                        style="
                          font-size: 12px;
                          margin: 5px 0 0 0px;
                          text-align: left;
                          color: #b3b3b3;
                        "
                      >
                        庭审视频数据来源于中国庭审视频公开网
                      </p>
                    </div>
                  </div>
                </div>
                <div class="txt01">
                  <h2>文书正文</h2>
                  <div v-if="content">
                    <!-- <el-button-group>
                      <el-button size="mini" round class="btn" type="warning"
                        >A<i class="el-icon-minus"></i
                      ></el-button>
                      <el-button class="btn" size="mini" round type="warning"
                        >A<i class="el-icon-plus"></i
                      ></el-button>
                    </el-button-group> -->
                    <div class="font_">
                      字号&emsp;
                      <span @click="increaseFontSize"> A+ </span>
                      &ensp;
                      <span @click="decreaseFontSize"> A- </span>
                    </div>
                    <el-button
                      type="warning"
                      round
                      @click="copyAll"
                      class="btn"
                      data-clipboard-target="#text"
                      data-clipboard-action="copy"
                      size="mini"
                      style="margin: 0px 10px"
                      >复制全文</el-button
                    >
                  </div>
                </div>

                <div
                  id="text"
                  :style="{ fontSize: fontSize + 'px' }"
                  v-html="content"
                  class="box00"
                ></div>

                <!-- <div
              class="txt"
              v-for="(item, index) in casenew.Content_kv"
              :key="index"
              :id="'item' + index"
            >
              <h2 v-if="item.key !== ''">{{ item.key }}</h2>
              <div
                class="content"
                style="line-height: 30px; white-space: pre-wrap"
                v-if="item.key !== ''"
                v-html="item.values"
              >
              </div>
            </div> -->
              </div>
              <div
                class="box_body"
                ref="backTop"
                id="top"
                v-if="content == '' && casenew.Trial"
              >
                <div class="txt" id="item00">
                  <h2>基本信息</h2>
                  <div
                    class="content"
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <img
                      v-if="casenew.Trial.img_link.includes('showPlay')"
                      style="
                        max-width: 30%;
                        max-height: 160px;
                        border-radius: 5px;
                      "
                      src="../../../../assets/imgs/picwish(1).png"
                      alt=""
                    />
                    <img
                      v-else
                      style="width: 30%; border-radius: 5px"
                      :src="casenew.Trial.img_link"
                      alt=""
                    />
                    <div style="width: 65%">
                      <span v-if="casenew.CaseId" class="span_css"
                        >案&emsp;&emsp;号：{{ casenew.CaseId }}</span
                      >
                      <span v-if="casenew.Trial.BeginTime" class="span_css"
                        >开庭时间：{{ casenew.Trial.BeginTime }}</span
                      >

                      <span v-if="casenew.Court" class="span_css"
                        >审理法院：
                        <!-- {{ casenew.Court.names[casenew.Court.names.length - 1] }} -->
                        {{ cours_name }}
                      </span>
                      <span v-if="casenew.Trial.Locate" class="span_css"
                        >庭审地点：{{ casenew.Trial.Locate }}</span
                      >

                      <span
                        v-if="casenew.Cause_Reason.length > 0"
                        class="span_brief"
                        ><span class="span_tit"> 案&emsp;&emsp;由：</span>
                        <span style="display: inline-block">
                          <span
                            v-for="(item, index) in briefs"
                            :key="index"
                            @click="search_brief(item)"
                          >
                            <span class="hover_brief">{{ item.name }} </span>
                            <span v-if="index < briefs.length - 1">>> </span>
                          </span>
                        </span>
                      </span>
                      <div style="width: 100%">
                        <el-button
                          type="warning"
                          round
                          @click="video_link(casenew.Trial.video_link)"
                          class="btn"
                          size="mini"
                          style="margin: 10px 0"
                          >庭审视频链接</el-button
                        >
                      </div>

                      <p style="text-align: right; color: #b3b3b3">
                        庭审视频数据来源于中国庭审视频公开网
                      </p>
                    </div>
                  </div>
                </div>
                <div class="txt">
                  <!-- && parties[0].type !=='' && parties[1].type !=='' -->
                  <h2>审判组织和诉讼参与人</h2>
                  <div class="content">
                    <h2 class="h2_css_">审判组织成员</h2>
                    <div>
                      <span
                        v-for="(item, index) in casenew.Trial.Judge"
                        :key="index"
                        class="span_css"
                        >{{ item.role }}：{{ item.name }}</span
                      >
                    </div>
                    <h2 class="h2_css_">诉讼参与人</h2>
                    <div>
                      <span
                        v-for="(item, index) in casenew.Trial.Party"
                        :key="index"
                        class="span_css"
                        >{{ item.role }}：{{ item.name }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="new_box" v-if="content !== ''">
          <div class="collapse_" v-if="lawtkxs.length > 0 && !lawtkxs_show">
            <img src="../../../../assets/imgs/文书详情二期/u76.png" alt="" />
            <br />法<br />律<br />依<br />据<br />
            <i
              @click="lawtkxs_show = !lawtkxs_show"
              class="el-icon-s-unfold unfold_icon"
            ></i>
          </div>

          <div class="box_left" v-if="lawtkxs.length > 0 && lawtkxs_show">
            <h2 class="h_css_">
              <div class="h_css">
                <img
                  src="../../../../assets/imgs/文书详情二期/u76.png"
                  alt=""
                />
                <div class="tit_text">法律依据</div>
              </div>

              <i
                class="el-icon-s-fold unfold_icon"
                @click="lawtkxs_show = !lawtkxs_show"
              ></i>
            </h2>

            <el-divider style="margin: 5px 0"></el-divider>
            <div class="left_list font_size">
              <ul>
                <li v-for="(item, index) in lawtkxs" :key="index">
                  <el-popover
                    placement="left"
                    width="300"
                    trigger="hover"
                    :content="item.fv[0]"
                    v-if="item.fv.length > 0 && item.fv[0] !== ''"
                  >
                    <div
                      class="lis"
                      slot="reference"
                      @click="lawUrl(item.link)"
                    >
                      <!-- <div class="dot"></div> -->
                      <img
                        class="img_dot"
                        style=""
                        src="../../../../assets/imgs/文书详情二期/圆点大.png"
                        alt=""
                      />
                      <div class="li_content">
                        <span v-if="item.law && item.law !== ''"
                          >《{{ item.law }}》</span
                        ><span>{{ item.tkx }}</span>
                      </div>
                    </div>
                  </el-popover>
                  <div class="lis" v-else @click="lawUrl(item.link)">
                    <!-- <div class="dot"></div> -->
                    <img
                      class="img_dot"
                      style=""
                      src="../../../../assets/imgs/文书详情二期/圆点大.png"
                      alt=""
                    />
                    <div class="li_content">
                      <span v-if="item.law && item.law !== ''"
                        >《{{ item.law }}》</span
                      ><span>{{ item.tkx }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="collapse_" v-if="relations.length > 0 && !relations_show">
            <img src="../../../../assets/imgs/文书详情二期/u90.png" alt="" />
            <br />关<br />联<br />文<br />书<br />
            <i
              @click="relations_show = !relations_show"
              class="el-icon-s-unfold unfold_icon"
            ></i>
          </div>
          <div class="box_left" v-if="relations.length > 0 && relations_show">
            <h2 class="h_css_">
              <div class="h_css">
                <img
                  src="../../../../assets/imgs/文书详情二期/u90.png"
                  alt=""
                />
                <div class="tit_text">关联文书</div>
              </div>

              <i
                class="el-icon-s-fold unfold_icon"
                @click="relations_show = !relations_show"
              ></i>
            </h2>
            <el-divider style="margin: 5px 0"></el-divider>
            <div class="left_list font_size">
              <ul>
                <li v-for="(item, index) in relations" :key="index">
                  <div class="lis" @click="related_detail(item)">
                    <!-- <div class="dot"></div> -->
                    <img
                      class="img_dot"
                      style=""
                      src="../../../../assets/imgs/文书详情二期/圆点大.png"
                      alt=""
                    />
                    <div class="li_content">{{ item.Casename }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="collapse_" v-if="!similar_show && check_show_">
            <img
              src="../../../../assets/imgs/文书详情二期/leianjiansuo_.png"
              alt=""
            />
            <br />类<br />案<br />检<br />索<br />
            <i
              @click="similar_show = !similar_show"
              class="el-icon-s-unfold unfold_icon"
            ></i>
          </div>
          <div class="box_left" v-if="similar_show && check_show_">
            <h2 class="h_css_">
              <div class="h_css">
                <img
                  src="../../../../assets/imgs/文书详情二期/leianjiansuo_.png"
                  alt=""
                />
                <div class="tit_text">类案检索</div>
              </div>

              <i
                class="el-icon-s-fold unfold_icon"
                @click="similar_show = !similar_show"
              ></i>
            </h2>
            <el-divider style="margin: 5px 0"></el-divider>
            <div class="bnts">
              <el-button
                v-if="this.casenew && this.casenew.Cause_Reason.length > 0"
                :class="check.indexOf('1') !== -1 ? 'yes_check' : 'no_check'"
                type="warning"
                size="mini"
                style="letter-spacing: 2px"
                @click="detail_search('1')"
                >同案由</el-button
              >
              <el-tooltip
                class="item"
                placement="bottom"
                effect="light"
                content="暂无数据"
                v-else
              >
                <el-button type="info" size="mini">同案由</el-button>
              </el-tooltip>
              <el-button
                v-if="this.cours_name"
                :class="check.indexOf('2') !== -1 ? 'yes_check' : 'no_check'"
                type="warning"
                size="mini"
                style="letter-spacing: 2px"
                @click="detail_search('2')"
                >同法院</el-button
              >
              <el-tooltip
                class="item"
                placement="bottom"
                effect="light"
                content="暂无数据"
                v-else
              >
                <el-button type="info" size="mini">同法院</el-button>
              </el-tooltip>
              <!-- <el-popover
              placement="bottom"
              width="80"
              trigger="click"
              content="暂无数据"
              v-if="!word_show"
            >
              <el-button slot="reference" type="info" size="mini"
                >同关键词</el-button
              >
            </el-popover> -->
              <el-tooltip
                class="item"
                placement="bottom"
                effect="light"
                content="暂无数据"
                v-if="!word_show"
              >
                <el-button type="info" size="mini">同关键词</el-button>
              </el-tooltip>
              <!-- <el-button
              v-if="
                !word_show
              "
              
              type="info"
              size="mini"
              >同关键词</el-button
            > -->
              <el-button
                v-if="word_show"
                :class="check.indexOf('3') !== -1 ? 'yes_check' : 'no_check'"
                type="warning"
                size="mini"
                style="letter-spacing: 1px"
                @click="detail_search('3')"
                >同关键词</el-button
              >

              <el-button
                v-if="this.casenew && this.casenew.CaseType"
                :class="check.indexOf('4') !== -1 ? 'yes_check' : 'no_check'"
                type="warning"
                size="mini"
                @click="detail_search('4')"
                >同案件类型</el-button
              >
              <el-tooltip
                class="item"
                placement="bottom"
                effect="light"
                content="暂无数据"
                v-else
              >
                <el-button type="info" size="mini">同案件类型</el-button>
              </el-tooltip>
            </div>
            <div class="similar">
              <el-button type="text" @click="Similar">类案检索</el-button>
            </div>
            <div
              class="list_s font_size"
              v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
            >
              <ul v-if="btn_list.length > 0">
                <li v-for="(item, index) in btn_list" :key="index">
                  <div class="lis" @click="search_btn(item)">
                    <div style="width: 70px !important">
                      <el-tag
                        size="small"
                        type="warning"
                        v-for="(item, index) in item.Ref_level"
                        :key="index"
                        >{{ item }}</el-tag
                      >
                    </div>

                    <div class="li_content" style="width: calc(100% - 70px)">
                      {{ item.Casename }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="btn_list_wu" v-if="btn_list.length <= 0 && list_show">
                <div class="wu_img">
                  <img
                    src="../../../../assets/imgs/文书详情二期/暂无数据.png"
                    alt=""
                  />
                </div>

                <p>暂无数据</p>
              </div>
              <div class="similar" v-if="btn_list.length > 0">
                <el-button type="text" @click="more">更多 >></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import $ from "jquery";
import Clipboard from "clipboard"; //引入安装复制插件
import ComFooter from "../../../../components/ComFooter.vue";
export default {
  inject: ["reload"],
  data() {
    return {
      caseId: "",
      content: null,
      // boxNav: [
      //   "标题",
      //   "基本信息",
      //   "首部",
      //   "当事人信息",
      //   "诉讼记录",
      //   "事实",
      //   "理由",
      //   "判决结果",
      //   "尾部",
      // ],
      naveffect: null,
      casenew: {
        CaseId: "",
        CaseType: "",
        Court: {
          name: "",
        },
        TrialPro: "",
        RefereeDate: "",
      },
      causeReason: null,
      pageheight: null,
      boxNav: [],
      parameter: {},
      briefs: [],
      lawtkxs: [],
      relations: [],
      check: [],
      association: {
        reason: "",
        court: "",
        keyword: "",
        doctype: "",
        association: "",
      },
      parties: [],
      btn_list: [],
      list_show: true,
      loading: false,
      cours_name: "",
      word_show: true,
      fontSize: 16,
      lawtkxs_show: false,
      relations_show: false,
      similar_show: false,
      check_show_: false,
    };
  },
  created() {
    this.parameter = {
      //  _id:this.$route.params.id,
      type: this.$route.query.type,
      keyword: this.$route.query.keyword,
    };
    this.caseDetail();

    // console.log()
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // left: 0px;
    // top: 180px;
    increaseFontSize() {
      if (this.fontSize < 32) {
        this.fontSize += 2; // 增加字体大小 2px
      }
    },
    decreaseFontSize() {
      if (this.fontSize > 8) {
        this.fontSize -= 2; // 减小字体大小 2px
      }
    },

    handleScroll() {
      // console.log('滚动高度', window.pageYOffset)
      this.pageheight = window.pageYOffset;
      // console.log('距离顶部高度', this.$refs.backTop.getBoundingClientRect().top)
    },
    caseDetail() {
      this.caseId = this.$route.params.id;
      // console.log(this.caseId);
      window.scrollTo(0, 0);
      this.$http
        .get(
          "/info?_id=" +
            this.caseId +
            "&keyword=" +
            this.parameter.keyword +
            "&type=" +
            this.parameter.type
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.content = res.data.data.Content;
            // console.log(this.content)
            this.lawtkxs = res.data.data.lawtkx;
            this.parties = res.data.data.Party;
            this.relations = res.data.data.relation;
            // if (res.data.data.Party.length > 1) {
            //   this.parties = [];
            //   res.data.data.Party.forEach((item, index) => {
            //     let par = {
            //       type: item.type,
            //       name: item.name,
            //       lawfirm: "",
            //       law_name: "",
            //       role: "",
            //     };
            //     if (item.lawer.length > 0) {
            //       item.lawer.forEach((item, index) => {
            //         if (!par.lawfirm.includes(item.lawfirm)) {
            //           par.lawfirm = par.lawfirm + item.lawfirm;
            //         }
            //         par.law_name = par.law_name + item.name;
            //         if (index < item.lawer.length - 1) {
            //           par.lawfirm = par.lawfirm + " ; ";
            //         }
            //       });
            //     }
            //     this.parties.push(par);
            //   });
            // }

            this.boxNav = [];
            if (this.content.indexOf('></span><span class="port') !== -1) {
              // console.log("a");
              var reg = new RegExp('></span><span class="port', "g"); //g,表示全部替换。
              this.content = this.content.replace(
                reg,
                'style="display:none;"></span><span class="port'
              );
            }
            //  console.log(this.content);
            let location00 = /<br>/g;
            let a00 = this.content.replace(location00, "");

            let location01 = /id="1">/g;
            let a01 = a00.replace(
              location01,
              'id="1"><h2 class="h2_css" style=""> 首部 </h2>'
            );
            let or01 = location01.test(this.content);
            // console.log(or01);
            if (or01) {
              this.boxNav.push("首部");
            }
            let location02 = /id="2">/g;
            let a02 = a01.replace(
              location02,
              'id="2" ><h2 class="h2_css" >当事人</h2>'
            );
            let or02 = location02.test(a01);
            if (or02) {
              this.boxNav.push("当事人");
            }
            let location03 = /id="3">/g;
            let a03 = a02.replace(
              location03,
              'id="3" ><h2 class="h2_css" > 诉讼记录 </h2>'
            );
            let or03 = location03.test(a02);
            if (or03) {
              this.boxNav.push("诉讼记录");
            }
            let location04 = /id="4">/g;
            let a04 = a03.replace(
              location04,
              'id="4" ><h2 class="h2_css" > 事实 </h2>'
            );
            let or04 = location04.test(a03);
            if (or04) {
              this.boxNav.push("事实");
              console.log(a03);
            }
            let location05 = /id="5">/g;
            let a05 = a04.replace(
              location05,
              'id="5"><h2 class="h2_css" > 理由 </h2>'
            );
            let or05 = location05.test(a04);
            if (or05) {
              this.boxNav.push("理由");
            }
            let location06 = /id="6">/g;
            let a06 = a05.replace(
              location06,
              'id="6"><h2 class="h2_css" > 判决结果 </h2>'
            );
            let or06 = location06.test(a05);
            if (or06) {
              this.boxNav.push("判决结果");
            }
            let location07 = /id="7">/g;
            let a07 = a06.replace(
              location07,
              'id="7"><h2 class="h2_css" > 尾部 </h2>'
            );
            let or07 = location07.test(a06);
            if (or07) {
              this.boxNav.push("尾部");
            }
            let location08 = /id="8">/g;
            let a08 = a07.replace(
              location08,
              'id="8"><h2 class="h2_css" > 引用法条 </h2>'
            );
            let or08 = location08.test(a07);
            if (or08) {
              this.boxNav.push("引用法条");
            }
            let location09 = /id="9">/g;
            let a09 = a08.replace(
              location09,
              'id="9"> <h2 class="h2_css" > 关键词 </h2>'
            );
            let or09 = location09.test(a08);
            if (or09) {
              this.boxNav.push("关键词");
            }
            let location10 = /id="10">/g;
            let a10 = a09.replace(
              location10,
              'id="10"><h2 class="h2_css" > 要旨 </h2>'
            );
            let or10 = location10.test(a09);
            if (or10) {
              this.boxNav.push("要旨");
            }
            let location11 = /id="11">/g;
            let a11 = a10.replace(
              location11,
              'id="11"><h2 class="h2_css" > 基本案情 </h2>'
            );
            let or11 = location11.test(a10);
            if (or11) {
              this.boxNav.push("基本案情");
            }
            let location12 = /id="12">/g;
            let a12 = a11.replace(
              location12,
              'id="12"><h2 class="h2_css" > 检察机关履职情况 </h2>'
            );
            let or12 = location12.test(a11);
            if (or12) {
              this.boxNav.push("检察机关履职情况");
            }
            let location13 = /id="13">/g;
            let a13 = a12.replace(
              location13,
              'id="13"><h2 class="h2_css" > 指导意义 </h2>'
            );
            let or13 = location13.test(a12);
            if (or13) {
              this.boxNav.push("指导意义");
            }
            let location14 = /id="14">/g;
            let a14 = a13.replace(
              location14,
              'id="14"><h2 class="h2_css" > 相关规定 </h2>'
            );
            let or14 = location14.test(a13);
            if (or14) {
              this.boxNav.push("相关规定");
            }
            let location15 = /id="15">/g;
            let a15 = a14.replace(
              location15,
              'id="15"><h2 class="h2_css" > 裁判要点 </h2>'
            );
            let or15 = location15.test(a14);
            if (or15) {
              this.boxNav.push("裁判要点");
            }
            let location16 = /id="16">/g;
            let a16 = a15.replace(
              location16,
              'id="16"><h2 class="h2_css" > 裁判理由 </h2>'
            );
            let or16 = location16.test(a15);
            if (or16) {
              this.boxNav.push("裁判理由");
            }
            let location17 = /\/lawsDetail/g;
            let a17 = a16.replace(
              location17,
              window.location.origin + "/lawsDetail"
            );
            this.content = a17;
            // console.log(this.content);
            // console.log(this.boxNav);
            // this.boxNav.push("检察机关履职情况");
            this.casenew = res.data.data;
            this.cours_name =
              this.casenew.Court.names[this.casenew.Court.names.length - 1];
            this.briefs = [];
            // let reg = /[0-9]+/g;

            // let str1 = str.replace(reg,"");

            this.casenew.Cause_Reason.forEach((item, index) => {
              let brief_s = item.split(",");
              brief_s.forEach((item) => {
                let brief = {
                  name: item.replace(/[0-9]/g, ""),
                  code: item,
                };
                this.briefs.push(brief);
              });
            });
            // console.log("a");
            this.casenew.Keyword.forEach((item, index) => {
              console.log(item);
              if (item == "") {
                this.casenew.Keyword.splice(index, 1);
              }
            });
            console.log(this.casenew.Keyword);
            if (this.casenew.Keyword.length > 0) {
              this.word_show = true;
            } else {
              this.word_show = false;
            }

            // this.detail_search("1");
            this.casenew.Cause_Reason = [];
            // console.log(this.cours_name);
            this.check_show_ = true;

            if (this.casenew.fact) {
              this.association.case_description = this.casenew.fact;
            } else {
              this.association.case_description = "";
              if (this.casenew.Cause_Reason.length > 0) {
                let reas = this.casenew.Cause_Reason[0].split(",");

                reas = [reas[reas.length - 1]];
                this.association.reason = JSON.stringify(reas);
                this.check = ["1"];
              } else if (this.cours_name) {
                this.association.court = this.cours_name;
                this.check = ["2"];
              } else if (this.casenew.Keyword.length > 0) {
                this.association.keyword = JSON.stringify(this.casenew.Keyword);
                this.check = ["3"];
              } else if (this.casenew.CaseType) {
                this.association.doctype = JSON.stringify(
                  this.casenew.CaseType
                );
                this.check = ["4"];
              } else {
                this.check = [];
                this.check_show_ = false;
              }
            }
            this.loading = true;
            this.$http
              .post("/association", this.association)
              .then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                  this.btn_list = res.data.data;
                }
                this.loading = false;
              })
              .catch((error) => {
                console.log(error);
                this.loading = false;
              });

            // let a =/^(10\.\d{4,5}/[\d\:\.\,\(\)\;\[\]\_\<\>\&\-\+\/a-zA-Z]{1,200})*$/;
            // let b = "https://doi.org/10.1038/s41586-022-04426-5";
            // let c = b.replace(a)
            // console.log(c)
            // console.log(this.casenew);
            // this.causeReason = res.data.data.Cause_Reason[0].name;
            // console.log(this.causeReason)
            // console.log(this.casenew)
            // this.casenew.Content_kv.forEach((item) => {
            //   if (item.key !== "") {
            //     // console.log(typeof item.key)
            //     // this.boxNav.push(item.key);
            //     if (item.key !== "首部" && item.key !== "尾部") {
            //       let arr = item.values.split(/[\n]/);
            //       // console.log(arr)
            //       let lastValues = "";
            //       for (let i = 0; i < arr.length; i++) {
            //         let addContent =
            //           '<p style="text-indent: 2em">' + arr[i] + "</p>";
            //         // item.values = item.values + addContent;
            //         lastValues = lastValues + addContent;
            //       }
            //       // console.log(lastValues)
            //       item.values = lastValues;
            //     }
            //   }
            // });
            // // console.log(this.boxNav);
          }
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((reeor) => {
          // console.log(reeor);
          // store.clearCookie("token");
          // this.$router.push("/");
          // this.reload();
          // this.$message.error("登录过期！请重新登录");
        });
    },
    collectible(it) {
      console.log(it);
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: this.caseId,
          // role: store.getCookie("role"),
          doctype: 1,
          docname: it.Casename,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.caseDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: this.caseId,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.caseDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    // PDF单篇下载
    pdfDown(id) {
      // console.log(id);
      this.$http
        .get("/pdf?_id=" + id, {})
        .then((res) => {
          // console.log(res);
          // window.location.href = res.data.data.url;
          // window.open(res.data.data.url, "_blank");
          if (res.data.data.url) {
            window.open(res.data.data.url, "_blank");
          }
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // word单篇下载
    wordDown(id) {
      // console.log(id);
      this.$http
        .get("/word?_id=" + id, {})
        .then((res) => {
          // console.log(res);
          // window.location.href = res.data.data.url;
          // window.open(res.data.data.url, "_blank");
          if (res.data.data.url) {
            window.open(res.data.data.url, "_blank");
          }
          // if ((res.data.message == "token 无效") || (res.data.message == "token 过期")) {
          //   store.clearCookie("token");
          //   this.$router.push("/");
          //   this.reload();
          //   this.$message.error("登录过期！请重新登录");
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    boxnav(a, b) {
      console.log(a, b);
      this.naveffect = a;
      // if (b == 9) {
      //   // window.location.href = "#item6";
      //   // document.querySelector("#item6").scrollIntoView(true);
      //   $("html, body").animate({ scrollTop: $("#9").offset().top - 81 });
      // }
      if (a == "裁判理由") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#16").offset().top - 81 });
      }
      if (a == "裁判要点") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#15").offset().top - 81 });
      }
      if (a == "相关规定") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#14").offset().top - 81 });
      }
      if (a == "指导意义") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#13").offset().top - 81 });
      }
      if (a == "检察机关履职情况") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#12").offset().top - 81 });
      }
      if (a == "基本案情") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#11").offset().top - 81 });
      }
      if (a == "要旨") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#10").offset().top - 81 });
      }
      if (a == "关键词") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#9").offset().top - 81 });
      }
      if (a == "引用法条") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#8").offset().top - 81 });
      }
      if (a == "尾部") {
        // window.location.href = "#item6";
        // document.querySelector("#item6").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#7").offset().top - 81 });
      }
      if (a == "判决结果") {
        // window.location.href = "#item5";
        // document.querySelector("#item5").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#6").offset().top - 81 });
      }
      if (a == "理由") {
        // window.location.href = "#item4";
        // document.querySelector("#item4").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#5").offset().top - 81 });
      }
      if (a == "事实") {
        // window.location.href = "#item3";
        // document.querySelector("#item3").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#4").offset().top - 81 });
      }
      if (a == "诉讼记录") {
        // window.location.href = "#item2";
        // window.document.querySelector("#item2").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#3").offset().top - 81 });
      }
      if (a == "当事人") {
        // window.location.href = "#item1";
        // document.querySelector("#item1").scrollIntoView();
        $("html, body").animate({ scrollTop: $("#2").offset().top - 81 });
      }
      if (a == "首部") {
        // window.location.href = "#item0";
        // document.querySelector("#item0").scrollIntoView(true);
        $("html, body").animate({ scrollTop: $("#1").offset().top - 81 });
        // var target = document.getElementById("#item0");
        // target.parentNode.scrollTop = target.offsetTop;
      }
      // if (a == "基本信息") {
      //   // window.location.href = "#item00";
      //   $('html, body').animate({scrollTop: $("#item00").offset().top - 81});
      //   // document.querySelector("#item00").scrollIntoView(true);
      // }
      // if (a == "标题") {
      //   // window.location.href = "#item000";
      //   $('html, body').animate({scrollTop: $("#item000").offset().top - 81});
      //   // document.querySelector("#item000").scrollIntoView(true);
      // }
      // console.log(this.naveffect)
    },
    // 复制全文
    copyAll() {
      let textUrl = new Clipboard(".btn");
      textUrl.on("success", (e) => {
        console.log(e.action);
        this.$message({
          message: "复制成功",
          type: "success",
        });
        textUrl.destroy();
      });
      textUrl.on("error", () => {
        consold.log("没有复制成功");
        this.$message("没有复制成功");
        textUrl.destroy();
      });
      //创建一个 Input标签
      // let oInput = document.createElement("input");
      // oInput.value = this.detailAll.Content;
      // document.body.appendChild(oInput);
      // oInput.select(); // 选择对象;
      // console.log(oInput.value);
      // // 执行浏览器复制命令
      // /// 复制命令会将当前选中的内容复制到剪切板中
      // /// 如这里构建的 Input标签
      // document.execCommand("Copy");
      // this.$message({
      //   message: "复制成功",
      //   type: "success",
      // });
      // ///复制成功后再将构造的标签 移除
      // oInput.remove();
    },
    // 案由跳转
    search_brief(data) {
      console.log(data);

      let brief = [["Reason", [data.code]]];
      window.localStorage.setItem("search_new", JSON.stringify(brief));
      this.$router.push({ path: "/case" });
      return;
      let briefObj = [
        {
          name: data.name,
          lab: data.code,
          type: "brief",
        },
      ];

      window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));

      // window.sessionStorage.setItem("searchinput", "");
      window.sessionStorage.setItem("search", "");
      this.$router.push({ path: "/case" });
    },

    detail_search(id) {
      this.loading = true;
      if (this.check.indexOf(id) == -1) {
        console.log("a");
        this.check.push(id);
        if (this.check.indexOf("1") !== -1) {
          if (this.casenew.Cause_Reason.length > 0) {
            let reas = this.casenew.Cause_Reason[0].split(",");
            reas = [reas[reas.length - 1]];
            this.association.reason = JSON.stringify(reas);
          } else {
            this.association.reason = "";
          }
        }
        if (this.check.indexOf("2") !== -1) {
          this.association.court = this.cours_name;
        }
        if (this.check.indexOf("3") !== -1) {
          if (this.casenew.Keyword.length > 0) {
            this.association.keyword = JSON.stringify(this.casenew.Keyword);
          } else {
            this.association.keyword = "";
          }
        }
        if (this.check.indexOf("4") !== -1) {
          this.association.doctype = this.casenew.CaseType;
        }
        this.$http
          .post("/association", this.association)
          .then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.btn_list = res.data.data;
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } else {
        // console.log("b");
        // if (this.check.length > 1) {
        let index = this.check.indexOf(id);
        this.check.splice(index, 1);
        if (id == "1") {
          this.association.reason = "";
        }
        if (id == "2") {
          this.association.court = "";
        }
        if (id == "3") {
          this.association.keyword = "";
        }
        if (id == "4") {
          this.association.doctype = "";
        }
        // }
        if (
          this.check.indexOf("3") !== -1 &&
          this.check.length == 1 &&
          this.casenew.Keyword.length <= 0
        ) {
          this.btn_list = [];
          this.loading = false;
        } else {
          this.$http
            .post("/association", this.association)
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.btn_list = res.data.data;
                this.loading = false;
              } else {
                this.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            });
        }
      }
      if (this.check.indexOf("3") !== -1 && this.check.length == 1) {
        this.btn_list = [];
        this.loading = false;
      }

      // this.check = id;
      // console.log(this.casenew.Keyword);
      // if (id == "1") {
      //   let reas = this.casenew.Cause_Reason[0].split(",");
      //   reas = [reas[reas.length - 1]];
      //   this.association = {
      //     reason: JSON.stringify(reas),
      //     court: "",
      //     keyword: "",
      //     doctype: "",
      //   };
      // } else if (id == "2") {
      //   this.association = {
      //     reason: "",
      //     court: this.casenew.Court.name,
      //     keyword: "",
      //     doctype: "",
      //   };
      // } else if (id == "3") {
      //   this.association = {
      //     reason: "",
      //     court: "",
      //     keyword: JSON.stringify(this.casenew.Keyword),
      //     doctype: "",
      //   };
      // } else {
      //   this.association = {
      //     reason: "",
      //     court: "",
      //     keyword: "",
      //     doctype: this.casenew.CaseType,
      //   };
      // }
      // console.log(this.casenew.Keyword);
      // if (this.casenew.Keyword.length > 0 || id !== "3") {
      //   this.$http
      //     .post("/association", this.association)
      //     .then((res) => {
      //       console.log(res);
      //       if (res.data.code == 200) {
      //         this.btn_list = res.data.data;
      //       }
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // }

      this.list_show = true;
    },

    search_btn(data) {
      window.open(
        window.location.origin +
          "/detail/" +
          data._id +
          "?keyword=" +
          this.$route.query.keyword +
          "&type" +
          this.$route.query.type,
        "_blank"
      );
    },
    lawUrl(url) {
      window.open(window.location.origin + url, "_blank");
    },
    related_detail(data) {
      window.open(
        window.location.origin +
          "/detail/" +
          data._id +
          "?keyword=" +
          this.$route.query.keyword +
          "&type" +
          this.$route.query.type,
        "_blank"
      );
    },
    Similar() {
      let briefObj = [
        // {
        //   name: this.briefs[this.briefs.length - 1].name,
        //   lab: this.briefs[this.briefs.length - 1].code,
        //   type: "brief",
        // },
        // {
        //   name: this.casenew.Court.name,
        //   type: "region",
        // },
        // {
        //   name: this.casenew.CaseType,
        //   type: "casetype",
        // },
      ];
      if (this.casenew.fact) {
        // console.log('a')
        let fact_ = ["case_description", [["and", this.casenew.fact, "2"]]];
        briefObj.push(fact_);
      } else {
        if (this.briefs.length > 0) {
          // let brief = {
          //   name: this.briefs[this.briefs.length - 1].name,
          //   lab: this.briefs[this.briefs.length - 1].code,
          //   type: "brief",
          // };
          let brief = ["Reason", [this.briefs[this.briefs.length - 1].code]];
          briefObj.push(brief);
        }
        if (this.casenew.Keyword.length > 0) {
          // let work = {
          //   name: this.casenew.Keyword,
          //   type: "word",
          // };
          let work = ["Keyword", this.casenew.Keyword];
          briefObj.push(work);
        }
        if (this.cours_name !== "") {
          // let region = {
          //   name: this.cours_name,
          //   type: "region",
          // };
          let region = ["Court", [this.cours_name]];
          briefObj.push(region);
        }
        if (this.casenew.CaseType !== "") {
          // let casetype = {
          //   name: this.casenew.CaseType,
          //   type: "casetype",
          // };
          let casetype = ["CaseType", [this.casenew.CaseType]];
          briefObj.push(casetype);
        }
        // console.log(briefObj)
        
      }
      window.localStorage.setItem("search_new", JSON.stringify(briefObj));
// return
      this.$router.push({ path: "/case" });
      return;
      window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));
      window.sessionStorage.setItem("search", "");
      // this.$router.push({ path: "/case" });
      let routeUrl = this.$router.resolve({
        path: "/case",
        query: {
          sort: 1,
        },
      });

      window.open(routeUrl.href, "_blank");
    },
    more() {
      // if (this.check == "1") {
      //   let briefObj = [
      //     {
      //       name: this.briefs[this.briefs.length - 1].name,
      //       lab: this.briefs[this.briefs.length - 1].code,
      //       type: "brief",
      //     },
      //   ];
      //   window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));
      // } else if (this.check == "2") {
      //   let briefObj = [
      //     {
      //       name: this.casenew.Court.name,
      //       type: "region",
      //     },
      //   ];
      //   window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));
      // } else if (this.check == "3") {
      //   let briefObj = [
      //     {
      //       name: this.casenew.Keyword,
      //       type: "word",
      //     },
      //   ];
      //   window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));
      // } else {
      //   // casenew.CaseType
      //   let briefObj = [
      //     {
      //       name: this.casenew.CaseType,
      //       type: "casetype",
      //     },
      //   ];
      //   window.sessionStorage.setItem("searchinput", JSON.stringify(briefObj));
      // }
      // console.log(this.check)
      // return
      let ser_Obj = [];
      if (this.casenew.fact) {
        let fact_ = ["case_description", [["and", this.casenew.fact, "2"]]];
        ser_Obj.push(fact_);
      } else {
        if (this.check.indexOf("1") !== -1) {
          // let briefObj = {
          //   name: this.briefs[this.briefs.length - 1].name,
          //   lab: this.briefs[this.briefs.length - 1].code,
          //   type: "brief",
          // };
          let briefObj = ["Reason", [this.briefs[this.briefs.length - 1].code]];
          ser_Obj.push(briefObj);
        }
        if (this.check.indexOf("2") !== -1) {
          // let briefObj = {
          //   name: this.cours_name,
          //   type: "region",
          // };
          let briefObj = ["Court", [this.cours_name]];
          ser_Obj.push(briefObj);
        }
        if (this.check.indexOf("3") !== -1 && this.casenew.Keyword.length > 0) {
          // let briefObj = {
          //   name: this.casenew.Keyword,
          //   type: "word",
          // };
          let briefObj = ["Keyword", this.casenew.Keyword];
          ser_Obj.push(briefObj);
        }
        if (this.check.indexOf("4") !== -1) {
          // let briefObj = {
          //   name: this.casenew.CaseType,
          //   type: "casetype",
          // };
          let briefObj = ["CaseType", [this.casenew.CaseType]];
          ser_Obj.push(briefObj);
        }
      }

      window.localStorage.setItem("search_new", JSON.stringify(ser_Obj));
      this.$router.push({ path: "/case" });
      return;
      console.log(ser_Obj);
      window.sessionStorage.setItem("searchinput", JSON.stringify(ser_Obj));
      // return
      // let aa = JSON.parse(window.sessionStorage.getItem("searchinput"));
      // aa.forEach((item) => {
      //   if (item.type == "word") {
      //     console.log(item)
      //     if(Array.isArray(item.name)){
      //       console.log(item.name)
      //     }else{
      //       console.log('a')
      //     }
      //   }
      // });
      // return
      // window.sessionStorage.setItem("searchinput", "");
      window.sessionStorage.setItem("search", "");
      // this.$router.push({ path: "/case" });
      let routeUrl = this.$router.resolve({
        path: "/case",
        query: {
          sort: 1,
        },
      });

      window.open(routeUrl.href, "_blank");
    },
    video_link(link) {
      window.open(link, "_blank");
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style lang='less' scoped>
.detail__ {
  background: rgb(245, 239, 228);
  min-width: 1280px;
  .detail_box {
    background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 1000px;
    background-repeat: no-repeat;
    min-width: 1280px;
  }
}
.box {
  // background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  // min-width: 1260px;
  min-width: 1280px;
  // max-width: 1280px;
  min-height: calc(100vh - 200px);
  width: 1280px;
  margin: auto;
  line-height: 30px;
}
.detail {
  // min-width: 1100px;
  // width: 80%;
  // width: 52.5%;
  // max-width: 1260px;

  margin: 0 0 0 100px;

  // padding: 0 18%;
  .breadcrumb {
    margin: 20px 0 20px 28px;
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    background: #ffffff;
    margin-left: 20px;
    padding: 10px;
    // border-radius: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    // width: 100%;

    h1 {
      width: 100%;
      font-size: 21px;
      font-weight: 600;
      line-height: 60px;
      text-align: center !important;
      // margin-bottom: 20px;
      display: inline-block;
      //
    }
    p {
      margin-bottom: 10px;
      span {
        margin-right: 30px;
        // font-family: ;
      }
    }
  }
  .box::-webkit-scrollbar {
    // display: none;
  }
  .box_botton {
    // position: relative;
    // margin-top: 30px;
    // width: 1280px;

    .box_nav {
      // width: 300px;
      // position: absolute;
      // left: -300px;
      // width: 130px;
      float: left;
      position: relative;
      left: -100px;
      top: -120px;

      // top: -110px;
      // height: 800px;
      // position: fixed !important;
      // position:absolute !important;
      // left: 0px;
      // top: 180px;
      // border-right: 2px solid rgb(134, 134, 134);
      .post {
        position: fixed;
        .active__ {
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          border-right: 2px solid rgb(134, 134, 134);
        }
        span {
          width: 100px;
          // line-height: 20px;
          padding-right: 20px;
          display: block;
          text-align: right;

          cursor: pointer;
        }
      }
    }
    .box_body {
      // margin-left: 36px;
      background: #ffffff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      // border-radius: 10px;
      margin: 0px 0 20px 20px;
      .box00 {
        // position: absolute;
        /deep/ a {
          color: #88adff !important;
        }
        padding: 10px 0;

        /deep/ span {
          // display: inline-block;
          // margin: 20px 0;
        }
        /deep/ div {
          // width: 1000px;
          margin: 0 20px;
          padding: 0px 20px;
          text-indent: 2em;
          background: #f8f7f6;
        }
      }
      .txt {
        padding-bottom: 10px;
        padding-top: 10px;
        margin-bottom: 20px;
        h2 {
          padding-left: 10px;
          font-size: 18px;
          font-weight: 600;
          border-left: 3px solid #fad60c;
        }
        .content {
          border-radius: 10px;
          background: #f8f7f6;
          margin: 20px;
          padding: 10px 30px;
          .span_css {
            min-width: 50%;
            display: inline-block;
            height: 36px;
            line-height: 36px;
          }
          .span_brief {
            min-width: 100%;
            display: inline-block;
            // height: 36px;
            // line-height: 36px;

            .hover_brief {
              cursor: pointer;
              color: rgb(59, 156, 247);
            }
            .hover_brief:hover {
              color: rgb(94, 173, 248);
            }

            display: flex;
            .span_tit {
              display: inline-block;
              width: 85px;
            }
            .span_txt {
              width: 90%;
              display: inline-block;
            }
            .hover_brief_word:hover {
              // cursor: pointer;
              // color: rgb(94, 173, 248);
            }
          }
        }
      }
    }
  }
}
.txt01 {
  display: flex;
  justify-content: space-between;
  h2 {
    display: inline-block;
    padding-left: 10px;
    font-size: 18px;
    font-weight: 600;
    border-left: 3px solid #fad60c;
  }
}
.active {
  color: rgb(0, 0, 0);
  font-weight: 900;
  border-right: 2px solid rgb(0, 0, 0) !important;
}
.floatHeader {
  span {
    font-size: 21px;
    display: inline-block;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  min-width: 1280px;
  // display: none;
  // z-index: 2;
  position: fixed;
  // top: 10px;
  top: 0;
  width: 100% !important;
  height: 60px;
  // box-shadow: 0 0 5px rgb(0 0 0 / 20%);
  border-bottom: 1px solid #dadada;
  background: rgba(255, 255, 255, 0.9);
}
.collection {
  position: relative;
  top: 3px;
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
.down_icon {
  width: 20px;
  position: relative;
  top: 3px;
}
.h2_css_ {
  font-size: 16px !important;
  font-style: normal;
  padding: 0 !important;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #e6a23c;
  // margin: 0 20px;
  border: none !important;
  background: #f8f7f6;
}
.font_size {
  font-size: 16px;
}
.box00 {
  font-size: 16px;
  /deep/ .h2_css {
    font-size: 16px !important;
    font-style: normal;
    padding: 10px 10px;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #e6a23c;
    margin: 0 20px;
    background: #f8f7f6;
  }
}
.box {
  display: flex;
}
.new_box {
  // width: 20% !important;
  margin: 200px 20px 0 20px;
  font-size: 14px;
  .box_left {
    margin: 20px 0;
    padding: 10px;
    border-radius: 5px;
    width: 300px !important;
    min-height: 170px;
    // height: 500px;
    background-color: rgba(248, 247, 246, 1);
    /deep/ .el-divider--horizontal {
      margin: 5px 0;
    }
    .h_css_ {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .h_css {
      display: inline-block;
      // height: 50px;
      // line-height: 50px;
      display: flex;
      align-items: center;
      // position: relative;
      img {
        width: 35px;
      }

      .tit_text {
        margin: 0 5px;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
    .left_list {
      ul {
        li {
          margin: 0 10px;
          .lis {
            display: flex;
            // align-items: center;

            .li_content {
              line-height: 28px;
              cursor: pointer;
            }
            .li_content:hover {
              color: #e6a23c;
            }
          }
        }
      }
    }
    .bnts {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 0 0;
      /deep/ .el-button--mini,
      .el-button--mini.is-round {
        padding: 5px 5px;
      }
      .no_check {
        color: #e6a23c;
        background: #fdf6ec;
        border-color: #f5dab1;
      }
      .yes_check {
        color: #fff;
        background-color: #e6a23c;
        border-color: #e6a23c;
      }
    }
  }
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e6a23c;
  margin: 5px 10px 0 0;
}
.content0 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  img {
    width: 100px;
  }
  .party {
    border-radius: 10px;
    background: #f8f7f6;
    margin: 20px;
    padding: 20px 30px;
    width: 300px;
    p {
      // display: inline-block;
    }
  }
}
.similar {
  display: flex;
  justify-content: flex-end;
}
.list_s {
  ul {
    li {
      .lis {
        display: flex;
        background: #ececec;
        margin: 5px;
        padding: 5px;
        border-radius: 5px;
        .li_content {
          cursor: pointer;
          line-height: 25px;
          margin: 5px 5px 0px 5px;
        }
        .li_content:hover {
          color: #e6a23c;
        }
      }
    }
  }
}
.img_dot {
  width: 10px;
  height: 10px;
  margin: 10px 10px 0 0;
}
.btn_list_wu {
  .wu_img {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 180px;
      margin: auto;
    }
  }

  p {
    text-align: center;
    line-height: 50px;
  }
}
.party {
  height: 160px;
  p {
    // display: inline-block;
    // display: flex;
    // align-items: center;
  }
}
.figure.tit {
  display: inline-block;
}
.figure {
  width: 100%;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  white-space: nowrap; //文本强制不换行；
  text-overflow: ellipsis; //文本溢出显示省略号；
  overflow: hidden; //溢出的部分隐藏；
}
.figure_txt {
  // display: inline-block;
  // width: 200px;
}
.pop_txt {
  p {
    line-height: 25px;
  }
}
.font_ {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  padding: 0px 15px;
  color: #fff;
  background-color: #e6a23c;
  border-color: #e6a23c;
  font-size: 12px;
  border-radius: 15px;
  // span{
  //   display: inline-block;
  //   width: 30px;
  //   text-align: center;
  // }
  span:hover {
    cursor: pointer;
    // font-size: 15px;
    color: #000000;
  }
}
.unfold_icon {
  cursor: pointer;
  font-size: 25px;
  color: #e6a23c;
}
.collapse_ {
  width: 50px;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 0;
  background-color: #f8f7f6;
  border-radius: 5px;
  margin: 0 0 10px 0;
  img {
    width: 35px;
  }
}
</style>
<style  scoped>
.box00 >>> div {
  /* width: 500px; */
}
</style>